import { mapObject } from '@lucan/base-ui'
import { trasformaOptionsDisattivatePass } from '@lucan/base-ui-jconnet'
import { OPERAZIONI } from './ConfigurazioneApi'

const ELENCHI_PER_CONFIG = {
  CFG_LINK_ACCESSO: 'link/accesso',
  CFG_LINK_RITORNO_SPID: 'link/ritorno_spid',
  CFG_LINK_FORM_GENERICA: 'link/form_generica',
  CFG_LINK_FORM_INDIRIZZO: 'link/form_indirizzo',
  CFG_LINK_FORM_ANAGRAFICA: 'link/form_anagrafica',
  CFG_LINK_FORM_PATENTE: 'link/form_patente',
  CFG_LINK_FORM_CARICA_FILE: 'link/form_carica_file',
  CFG_LINK_SERVIZI: 'link/servizi',

  CFG_FRONTOFFICE_HEADER: 'frontoffice/header',
  CFG_FRONTOFFICE_HOME: 'frontoffice/home',
  CFG_FRONTOFFICE_ELENCO_VERBALI: 'frontoffice/elenco_verbali',
  CFG_FRONTOFFICE_VERBALE: 'frontoffice/verbale',
  CFG_FRONTOFFICE_VERBALE_INFORMATIVA: 'frontoffice/verbale_informativa',
  CFG_FRONTOFFICE_VERBALE_DATI_PERSONALI: 'frontoffice/verbale_dati_personali',
  CFG_FRONTOFFICE_VERBALE_RIEPILOGO: 'frontoffice/verbale_riepilogo',
  CFG_FRONTOFFICE_VERBALE_PAGAMENTO: 'frontoffice/verbale_pagamento',
  CFG_FRONTOFFICE_VERBALE_RITORNO_PAGAMENTO: 'frontoffice/verbale_ritorno_pagamento',
  CFG_FRONTOFFICE_PREAVVISO: 'frontoffice/preavviso',
  CFG_FRONTOFFICE_CONDIVISO: 'frontoffice/condiviso',

  CFG_DATICONDUCENTE_CONDIVISO: 'datiConducente/condiviso',
  CFG_DATICONDUCENTE_HOME: 'datiConducente/home',
  CFG_DATICONDUCENTE_ELENCO_VERBALI: 'datiConducente/elenco_verbali',
  CFG_DATICONDUCENTE_VERBALE: 'datiConducente/verbale',
  CFG_DATICONDUCENTE_VERBALE_INFORMATIVA: 'datiConducente/verbale_informativa',
  CFG_DATICONDUCENTE_VERBALE_RIEPILOGO: 'datiConducente/verbale_riepilogo',
  CFG_DATICONDUCENTE_VERBALE_DECURTAZIONE: 'datiConducente/verbale_decurtazione',
  CFG_DATICONDUCENTE_VERBALE_COMPLETAMENTO: 'datiConducente/verbale_completamento',

  CFG_PASS_CONDIVISO: 'pass/condiviso',
  CFG_PASS_HEADER: 'pass/header',
  CFG_PASS_HOME: 'pass/home',
}

const ELENCHI = {
  ...ELENCHI_PER_CONFIG,

  NAZIONI: 'nazioni',
  TIPI_INDIRIZZO: 'tipiIndirizzo',
  ENTI_PATENTE: 'entiPatente',
  TIPI_VEICOLO: 'tipiVeicolo',

  PASS_GRUPPI_TIPOLOGIE: 'passGruppiTipologie',
  PASS_PREFISSI: 'passPrefissi',
  PASS_TIPOLOGIE: 'passTipologie',
  PASS_VARCHI: 'passVarchi',
  PASS_ZONE_SOSTA: 'passZoneSosta',
  PASS_MOTIVAZIONI_MODIFICA_TARGA: 'passMotivazioniModificaTarga',
}

const configElenchiPerConfig = {
  promise: async configElenco => {
    const { inviaOperazione, operationDataExtra = null, chiave } = configElenco
    const { lingua, cmd } = operationDataExtra
    return await inviaOperazione(OPERAZIONI.CONFIGURAZIONE_GET, null, {}, { urlParams: { cmd, chiave, lingua } })
  }
}

const configTabelleDominio = ({ trasformaElenco, ...restConfig }) => ({
  promise: async configElenco => {
    const { inviaOperazione, chiave: tabella } = configElenco
    const { ok, data, error } = await inviaOperazione(OPERAZIONI.TABELLA_DOMINIO, null, {}, { urlParams: { tabella } })
    if (ok) return { ok: true, data: trasformaElenco(data) }
    return { ok: false, error: error.messaggi[0]?.msg }
  },
  ...restConfig
})

const configDizionariPass = ({ trasformaElenco, ...restConfig }) => ({
  promise: async configElenco => {
    const { inviaOperazione, chiave, dizionario } = configElenco
    const nome = dizionario || chiave
    const { ok, data, error } = await inviaOperazione(OPERAZIONI.PASS_DIZIONARI, { nome }, {}, { withCredentials: true })
    if (ok && data.esito) return { ok: true, data: trasformaElenco(data.data[nome]) }
    return { ok: false, error: error.messaggi[0]?.msg }
  },
  ...restConfig
})

const ELENCHI_CONFIG = {
  /************* Config *************/

  ...mapObject(ELENCHI_PER_CONFIG, ([, chiaveConfig]) => ([chiaveConfig, configElenchiPerConfig])),

  /**********************************/

  /********* Tabelle dominio *********/

  [ELENCHI.NAZIONI]: configTabelleDominio({
    trasformaElenco: nazioni => nazioni.map(({ nazione, nazione_ita }) => ({
      value: nazione,
      label: nazione_ita,
    }))
  }),

  [ELENCHI.TIPI_INDIRIZZO]: configTabelleDominio({
    trasformaElenco: tipi => tipi.map(({ key, value }) => ({
      value: key,
      label: value,
    }))
  }),

  [ELENCHI.ENTI_PATENTE]: configTabelleDominio({
    trasformaElenco: enti => enti.map(({ key, value }) => ({
      value: key,
      label: value,
    }))
  }),

  [ELENCHI.TIPI_VEICOLO]: configDizionariPass({
    dizionario: 'tipi_veicolo',
    trasformaElenco: tipiVeicolo => tipiVeicolo.map(({ tag, description }) => ({
      value: tag,
      label: description,
    }))
  }),

  /***********************************/

  /************* Pass *************/

  [ELENCHI.PASS_GRUPPI_TIPOLOGIE]: configDizionariPass({
    trasformaElenco: gruppi => trasformaOptionsDisattivatePass(gruppi)
  }),

  [ELENCHI.PASS_PREFISSI]: configDizionariPass({
    trasformaElenco: prefissi => trasformaOptionsDisattivatePass(prefissi)
  }),

  [ELENCHI.PASS_TIPOLOGIE]: configDizionariPass({
    trasformaElenco: tipologie => trasformaOptionsDisattivatePass(tipologie, true)
  }),

  [ELENCHI.PASS_VARCHI]: configDizionariPass({
    trasformaElenco: varchi => trasformaOptionsDisattivatePass(
      varchi.map(({ matricole, ...rest }) => ({
        ...rest,
        // Arrivano come array di stringhe, ma qui è più comodo un array di oggetti { matricola: '...' } 
        matricole: matricole.map(matricola => ({ matricola }))
      }))
    )
  }),

  [ELENCHI.PASS_ZONE_SOSTA]: configDizionariPass({
    trasformaElenco: zone => trasformaOptionsDisattivatePass(zone, true)
  }),

  [ELENCHI.PASS_MOTIVAZIONI_MODIFICA_TARGA]: configDizionariPass({
    trasformaElenco: motivazioni => [{ value: '', label: '' }, ...motivazioni],
  }),

  /********************************/
}

export {
  ELENCHI,
  ELENCHI_CONFIG,
}